<template lang="html">
	<div id="app">
    <div class="row">
      <div class="col-xs-12">
        <div class="sidebar">
          <button id="item_structure_save"
                  :title="$t('save')" @click="saveItemValidationRules">
            <span uk-icon="save"></span>
            <span class="title">{{ $t('save') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="main demo">
          <div class="demo-content nested v-row">
            <div class="v-col--33">
              <div class="filter">
                <div class="new-elements">
                  <div class="panel panel--filter">
                    <div class="panel__heading">
                      <h3>{{ $t('elements.list') }}</h3>
                    </div>
                    <div class="panel__body">
                      <div class="filter-control">
                        <input type="text" class="input" placeholder="Search"
                               v-model="currentFilterValue">
                        <span class="clear"
                              @click="clearFilter">&times;</span>
                      </div>
                      <vddl-list class="panel__body--list"
                                 :list="filterData"
                                 :allowed-types="['list']"
                                 :horizontal="false">
                        <vddl-draggable class="panel__body--item" v-for="(item, index) in filterData"
                                        :key="item.id"
                                        :draggable="{ title: item.title, type: 'ATTRIBUTE' }"
                                        :index="index"
                                        :type="'itemList'"
                                        :wrapper="filterData"
                                        effect-allowed="move"
                                        :selected="handleSelected"
                                        :moved="handleMovedItemList"
                                        :class="{'selected': selectedItem === item.title}">
                          <span class="fa fa-ellipsis-v drag"></span> {{ item.localization ||
                        item.title }} <br><span>{{'{' + item.title + '}'}}</span>
                        </vddl-draggable>
                      </vddl-list>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="v-col--33">
              <p v-if="!checkedTabs" class="tab--preview">{{ $t('select.tab.to.setting') }}</p>
              <div class="validation-rules">
                <div class="tab" v-for="panel in dropzones" :id="panel.name" :key="panel.name">
                  <div class="panel">
                    <div class="panel__heading">
                      <h3>{{ panel.name }}</h3>
                    </div>
                    <div class="panel__body scroll_panel__body">
                      <div class="filter-control">
                        <input type="text" class="input" placeholder="Search"
                               v-model="currentValidationFilterValue">
                        <span class="clear"
                              @click="clearValidationFilter">&times;</span>
                      </div>
                      <div class="validation-rules-tab-content">
                        <div class="panel padding">
                          <div class="panel__heading">
                            <h3><span class="fa fa-ellipsis-v drag"></span>required</h3>
                          </div>
                          <vddl-list class="panel__body"
                                     :list="panel.required"
                                     :drop="handleDrop"
                                     :moved="handleMoved"
                                     :allowed-types="['list', 'container', 'itemList']"
                                     :external-sources="true">
                            <list-required v-for="(col, index) in panel.required"
                                           v-show="isValidationItemVisible(col)"
                                           :key="col.id"
                                           :item="col"
                                           :list="panel.required"
                                           :index="index"
                                           :localization="localization"
                                           :item-structure="itemStructure"
                                           :dropzones="dropzones"
                                           :toggle-input-edit="toggleInputEdit"
                                           :on-delete="clearValidationFilter"
                                           :search-text="currentValidationFilterValue"
                            >
                            </list-required>
                          </vddl-list>
                        </div>
                        <div class="panel padding">
                          <div class="panel__heading">
                            <h3><span class="fa fa-ellipsis-v drag"></span>condition</h3>
                          </div>
                          <vddl-list class="panel__body"
                                     :drop="handleDropCondition.bind(this, panel)"
                                     :allowed-types="['list', 'container', 'itemList']"
                                     :external-sources="true">
                            <list-condition
                                :item="panel.condition"
                                :localization="localization"
                                :item-structure="itemStructure"
                                :dropzones="panel"
                                :toggle-input-edit="toggleInputEdit"
                            >
                            </list-condition>
                          </vddl-list>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="v-col--33">
              <div class="tab-list">
                <div class="new-elements disable-element">
                  <div class="panel panel--tabs">
                    <div class="panel__heading">
                      <h3>{{$t('selected.tabs')}}</h3>
                      <span class="fa fa-plus add-tab" title="Add tab" @click="addTab()"></span>
                    </div>
                    <div class="panel__body">
                      <div id="example-3" class="tabs">
                        <vddl-list class="panel__body--list"
                                   :list="dropzones"
                                   :drop="dropTab"
                                   :allowed-types="['itemTab', 'newTab']"
                                   :horizontal="false">
                          <vddl-draggable class="panel__body--item tab-item"
                                          v-for="(item, index) in filterTabs"
                                          :key="index"
                                          :draggable="item"
                                          :index="index"
                                          :type="'itemTab'"
                                          :wrapper="filterTabs"
                                          effect-allowed="move"
                                          :disable-if="disableTab"
                                          :moved="handleMovedTab"
                                          :class="{'search-highlight-tab': isTabHighlighted(item)}">
                            <span class="fa fa-ellipsis-v drag"></span> <input type="radio"
                                                                               :id="'radio_' + index"
                                                                               :value="item.name"
                                                                               v-model="checkedTabs"/>
                            <label :for="'radio_' + index">{{$t(item.name) ||
                            item.title}}</label>
                            <input type="hidden" class="text-edit" v-model="item.name">
                            <span class="fa fa-pencil edit"
                                  @click="toggleInputEdit('tab-item', $event)"></span>
                            <span class="fa fa-trash delete" title="Delete" @click="deleteTab(item)"></span>
                          </vddl-draggable>
                        </vddl-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { arrayKey, removeAttributeId } from '@/services/shared'
import { CONFIGURATIONS_ITEM_STRUCTURE } from 'actions/configurations'
import { saveAttributes } from '@/core/shared'
import ListRequired from "components/item-validation-rules/list-required"
import ListCondition from "components/item-validation-rules/list-condition"

export default {
	name: 'ItemValidationRules',
	metaInfo () {
		return {
			title: this.$t('item.validation.rules')
		}
	},
	data () {
		return {
			type: 'tab',
			selectedItem: {
				title: this.$t('nothing not selected')
			},
			disable: false,
			currentFilterValue: '',
			currentFilterTabs: '',
			currentValidationFilterValue: '',
			checkedTabs: '',
			dropzones: [],
			itemStructure: [],
			localization: {},
			allAttributeGroupsName: [],
			currentAttributeGroupsName: [],
			unusedAttributeGroupsName: [],
      disableTab: false
		}
	},
	watch: {
		checkedTabs: function () {
			let tabList = document.getElementsByClassName('tab')
			for (let i = 0; i < tabList.length; i++) {
				if (this.checkedTabs === tabList[i].id) {
					if (document.getElementById(tabList[i].id).classList.contains('dn')) {
						document.getElementById(tabList[i].id).classList.remove('dn')
					}
				} else {
					document.getElementById(tabList[i].id).classList.add('dn')
				}
			}
		}
	},
	computed: {
		filterData () {
			let self = this
			if (this.currentFilterValue !== undefined && this.currentFilterValue !== '') {
				return this.unusedAttributeGroupsName.filter(function (d) {
					return d.title.toLowerCase().indexOf(self.currentFilterValue) !== -1 || d.title.toLowerCase().indexOf(self.currentFilterValue) !== -1
				})
			} else {
				return this.unusedAttributeGroupsName
			}
		},
		filterTabs () {
			let self = this
			if (this.currentFilterTabs !== undefined && this.currentFilterTabs !== '') {
				return this.dropzones.filter(function (d) {
					if (d.title.toLowerCase().indexOf(self.currentFilterTabs) !== -1) {
						return d
					} else {
						return d.title.toLowerCase().indexOf(self.currentFilterTabs) !== -1
					}
				})
			} else {
				return this.dropzones
			}
		}
	},
	methods: {
		getConfiguration: function () {
			this.$store.dispatch(CONFIGURATIONS_ITEM_STRUCTURE)
				.then(() => {
					this.dropzones = this.$store.getters.getItemValidationRules
					this.itemStructure = this.$store.getters.getItemStructure
					this.allAttributeGroupsName = arrayKey(this.$store.getters.getItemStructure)
				})
				.then(() => {
          for (var key in this.itemStructure) {
						this.unusedAttributeGroupsName.push({
							'title': key,
							'localization': this.$t(this.itemStructure[key].title) || this.itemStructure[key].title,
						})
					}

          if (this.dropzones[0]) {
            this.checkedTabs = this.dropzones[0].name
          }

					this.unusedAttributeGroupsName = this.unusedAttributeGroupsName.sort((a, b) => {
						if (a.localization > b.localization) {
							return 1
						}
						if (a.localization < b.localization) {
							return -1
						}
						return 0
					})
				})
				.catch(errors => {
					console.error(errors)
					this.rollbar.error('CONFIGURATIONS_ITEM_STRUCTURE', errors)
				})
		},
    saveItemValidationRules () {
      saveAttributes(removeAttributeId(this.dropzones), 'ITEM_VALIDATION_RULES')
    },
		clearFilter () {
			this.currentFilterValue = ''
		},
		clearValidationFilter () {
			this.currentValidationFilterValue = ''
		},
		isValidationItemVisible (item) {
			if (!item) return false
			if (this.currentValidationFilterValue !== undefined && this.currentValidationFilterValue !== '') {
				const searchLower = this.currentValidationFilterValue.toLowerCase()
				const attribute = item.attribute ? item.attribute.toLowerCase() : ''
				const localization = this.itemStructure[item.attribute] ?
					(this.$t(this.itemStructure[item.attribute].title) || this.itemStructure[item.attribute].title || '').toLowerCase() : ''
				return attribute.indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
			}
			return true
		},
		isTabHighlighted (tab) {
			if (!this.currentValidationFilterValue || this.currentValidationFilterValue === '') return false
			if (!tab.required || tab.required.length === 0) return false

			const searchLower = this.currentValidationFilterValue.toLowerCase()

			return tab.required.some(item => {
				if (!item) return false
				const attribute = item.attribute ? item.attribute.toLowerCase() : ''
				const localization = this.itemStructure[item.attribute] ?
					(this.$t(this.itemStructure[item.attribute].title) || this.itemStructure[item.attribute].title || '').toLowerCase() : ''
				return attribute.indexOf(searchLower) !== -1 || localization.indexOf(searchLower) !== -1
			})
		},
		toggleInputEdit (parentNode, event) {
			let span = event.target,
				label = event.target.previousElementSibling.previousElementSibling,
				input = event.target.previousElementSibling
			parentNode = span.closest('div.' + parentNode)

			input.getAttribute('type') === 'text' ? input.setAttribute('type', 'hidden') : input.setAttribute('type', 'text')
			if (span.classList.contains('fa-pencil')) {
				span.classList.remove('fa-pencil', 'edit')
				span.classList.add('fa-floppy-o', 'save')
				label.style.display = 'none'
        this.disableTab = true
			} else {
				span.classList.remove('fa-floppy-o', 'save')
				span.classList.add('fa-pencil', 'edit')
				label.removeAttribute('style')
        this.disableTab = false
			}
		},
		dropTab (data) {
			const { index, list, item } = data
      let name = item.name
      let sliceIndex = index

      let oldIndex = list.findIndex(item => item.name === name);
      if (oldIndex !== -1) {
        this.$delete(list, oldIndex);
      }

      if (oldIndex < index) {
        sliceIndex = index - 1
      }

      list.splice(sliceIndex, 0, item)

      this.$set(this, 'checkedTabs', null)
		},
		handleDrop (data) {
      console.log('drop required', data)
			let { index, list, item } = data
      let title = item.title
      let sliceIndex = index

      if (!title) {
        title = item.attribute
      }

      let oldIndex = list.findIndex(item => item.attribute === title);
      if (oldIndex !== -1) {
        this.$delete(list, oldIndex);
      }

      if (oldIndex < index && !item.title) {
        sliceIndex = index - 1
      }

      list.splice(sliceIndex, 0, {
        attribute: title
      })

      this.updateDropzones(this.dropzones, item)

		},
    handleMoved (item) {

    },
    handleDropCondition (tab, data) {
      console.log('drop condition', data, tab)
      let { list, item } = data
      let title = item.title

      if (!title) {
        title = item.attribute
      }

      if (!list) {
        this.$set(tab, 'condition', { attribute: title, value: null });
      } else {
        list.attribute = item.title
        list.value = null
      }
    },
		updateDropzones (obj, item) {

		},
		handleMovedItemList (item) {

		},
		handleMovedTab (item) {

		},
    deleteTab (tab) {
      let obj = this.dropzones
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].name === tab.name) {
          obj.splice(i, 1)
          i--
        }
      }
    },
    addTab () {
      const name = 'New tab ' + Math.random().toString(36).substring(2, 9)
      this.dropzones.push({
        name,
        required: []
      })
      this.checkedTabs = name
    },
		inserted (data) {
		},
		handleSelected (item) {
			this.selectedItem = item
		},
		diff () {
			this.unusedAttributeGroupsName = this.allAttributeGroupsName
				.filter(x => !this.currentAttributeGroupsName.includes(x))
				.concat(this.currentAttributeGroupsName.filter(x => !this.allAttributeGroupsName.includes(x)))
		}
	},
	components: {
    ListRequired,
    ListCondition
	},
	mounted() {
		this.getConfiguration()
		window.companyId = this.$store.getters.getProfile.companyId
	}
}
</script>

<style>
	h1, h2 {
		font-weight: 400
	}

	ul {
		list-style-type: none;
		padding: 0
	}

	#app {
		width: 100%;
    height: 90vh;
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50
	}

	.container {
		max-width: 980px;
		min-width: 730px;
		margin: 0 auto
	}

	.demo-content {
		width: 100%
	}

	.vddl-draggable, .vddl-list {
		position: relative;
		width: 100%;
	}

	.vddl-list {
		padding-left: 0;
		min-height: 40px
	}

	.vddl-dragging {
		opacity: .7
	}

	.vddl-dragging-source {
		display: none
	}

	.v-row {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-ms-flex-align: start;
		align-items: flex-start
	}

	.v-row > [class*=v-col--] {
		box-sizing: border-box
	}

	.v-row .v-col--auto {
		width: 100%
	}

	.v-row .v-col--100 {
		width: 100%;
		width: calc((100% - 15px * 0) / 1)
	}

	.v-row.v-row--no-gutter .v-col--100 {
		width: 100%
	}

	.v-row .v-col--95 {
		width: 95%;
		width: calc((100% - 15px * 0.05263157894736836) / 1.0526315789473684)
	}

	.v-row.v-row--no-gutter .v-col--95 {
		width: 95%
	}

	.v-row .v-col--90 {
		width: 90%;
		width: calc((100% - 15px * 0.11111111111111116) / 1.1111111111111112)
	}

	.v-row.v-row--no-gutter .v-col--90 {
		width: 90%
	}

	.v-row .v-col--85 {
		width: 85%;
		width: calc((100% - 15px * 0.17647058823529416) / 1.1764705882352942)
	}

	.v-row.v-row--no-gutter .v-col--85 {
		width: 85%
	}

	.v-row .v-col--80 {
		width: 80%;
		width: calc((100% - 15px * 0.25) / 1.25)
	}

	.v-row.v-row--no-gutter .v-col--80 {
		width: 80%
	}

	.v-row .v-col--75 {
		width: 75%;
		width: calc((100% - 15px * 0.33333333333333326) / 1.3333333333333333)
	}

	.v-row.v-row--no-gutter .v-col--75 {
		width: 75%
	}

	.v-row .v-col--70 {
		width: 70%;
		width: calc((100% - 15px * 0.4285714285714286) / 1.4285714285714286)
	}

	.v-row.v-row--no-gutter .v-col--70 {
		width: 70%
	}

	.v-row .v-col--66 {
		width: 66.66666666666666%;
		width: calc((100% - 15px * 0.5000000000000002) / 1.5000000000000002)
	}

	.v-row.v-row--no-gutter .v-col--66 {
		width: 66.66666666666666%
	}

	.v-row .v-col--65 {
		width: 65%;
		width: calc((100% - 15px * 0.5384615384615385) / 1.5384615384615385)
	}

	.v-row.v-row--no-gutter .v-col--65 {
		width: 65%
	}

	.v-row .v-col--60 {
		width: 60%;
		width: calc((100% - 15px * 0.6666666666666667) / 1.6666666666666667)
	}

	.v-row.v-row--no-gutter .v-col--60 {
		width: 60%
	}

	.v-row .v-col--55 {
		width: 55%;
		width: calc((100% - 15px * 0.8181818181818181) / 1.8181818181818181)
	}

	.v-row.v-row--no-gutter .v-col--55 {
		width: 55%
	}

	.v-row .v-col--50 {
		width: 50%;
		width: calc((100% - 15px * 1) / 2)
	}

	.v-row.v-row--no-gutter .v-col--50 {
		width: 50%
	}

	.v-row .v-col--45 {
		width: 45%;
		width: calc((100% - 15px * 1.2222222222222223) / 2.2222222222222223)
	}

	.v-row.v-row--no-gutter .v-col--45 {
		width: 45%
	}

	.v-row .v-col--40 {
		width: 40%;
		width: calc((100% - 15px * 1.5) / 2.5)
	}

	.v-row.v-row--no-gutter .v-col--40 {
		width: 40%
	}

	.v-row .v-col--35 {
		width: 35%;
		width: calc((100% - 15px * 1.8571428571428572) / 2.857142857142857)
	}

	.v-row.v-row--no-gutter .v-col--35 {
		width: 35%
	}

	.v-row .v-col--33 {
		width: 33.333333333333336%;
		width: calc((100% - 15px * 2) / 3)
	}

	.v-row.v-row--no-gutter .v-col--33 {
		width: 33.333333333333336%
	}

	.v-row .v-col--30 {
		width: 30%;
		width: calc((100% - 15px * 2.3333333333333335) / 3.3333333333333335)
	}

	.v-row.v-row--no-gutter .v-col--30 {
		width: 30%
	}

	.v-row .v-col--25 {
		width: 25%;
		width: calc((100% - 15px * 3) / 4)
	}

	.v-row.v-row--no-gutter .v-col--25 {
		width: 25%
	}

	.v-row .v-col--20 {
		width: 20%;
		width: calc((100% - 15px * 4) / 5)
	}

	.v-row.v-row--no-gutter .v-col--20 {
		width: 20%
	}

	.v-row .v-col--15 {
		width: 15%;
		width: calc((100% - 15px * 5.666666666666667) / 6.666666666666667)
	}

	.v-row.v-row--no-gutter .v-col--15 {
		width: 15%
	}

	.v-row .v-col--10 {
		width: 10%;
		width: calc((100% - 15px * 9) / 10)
	}

	.v-row.v-row--no-gutter .v-col--10 {
		width: 10%
	}

	.v-row .v-col--5 {
		width: 5%;
		width: calc((100% - 15px * 19) / 20)
	}

	.v-row.v-row--no-gutter .v-col--5 {
		width: 5%
	}

	.v-row .v-col--auto:last-child, .v-row .v-col--auto:last-child ~ .v-col--auto {
		width: 100%;
		width: calc((100% - 15px * 0) / 1)
	}

	.v-row.v-row--no-gutter .v-col--auto:last-child, .v-row.v-row--no-gutter .v-col--auto:last-child ~ .v-col--auto {
		width: 100%
	}

	.v-row .v-col--auto:nth-last-child(2), .v-row .v-col--auto:nth-last-child(2) ~ .v-col--auto {
		width: 50%;
		width: calc((100% - 15px * 1) / 2)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(2), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(2) ~ .v-col--auto {
		width: 50%
	}

	.v-row .v-col--auto:nth-last-child(3), .v-row .v-col--auto:nth-last-child(3) ~ .v-col--auto {
		width: 33.33333333%;
		width: calc((100% - 15px * 2) / 3)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(3), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(3) ~ .v-col--auto {
		width: 33.33333333%
	}

	.v-row .v-col--auto:nth-last-child(4), .v-row .v-col--auto:nth-last-child(4) ~ .v-col--auto {
		width: 25%;
		width: calc((100% - 15px * 3) / 4)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(4), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(4) ~ .v-col--auto {
		width: 25%
	}

	.v-row .v-col--auto:nth-last-child(5), .v-row .v-col--auto:nth-last-child(5) ~ .v-col--auto {
		width: 20%;
		width: calc((100% - 15px * 4) / 5)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(5), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(5) ~ .v-col--auto {
		width: 20%
	}

	.v-row .v-col--auto:nth-last-child(6), .v-row .v-col--auto:nth-last-child(6) ~ .v-col--auto {
		width: 16.66666667%;
		width: calc((100% - 15px * 5) / 6)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(6), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(6) ~ .v-col--auto {
		width: 16.66666667%
	}

	.v-row .v-col--auto:nth-last-child(7), .v-row .v-col--auto:nth-last-child(7) ~ .v-col--auto {
		width: 14.28571429%;
		width: calc((100% - 15px * 6) / 7)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(7), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(7) ~ .v-col--auto {
		width: 14.28571429%
	}

	.v-row .v-col--auto:nth-last-child(8), .v-row .v-col--auto:nth-last-child(8) ~ .v-col--auto {
		width: 12.5%;
		width: calc((100% - 15px * 7) / 8)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(8), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(8) ~ .v-col--auto {
		width: 12.5%
	}

	.v-row .v-col--auto:nth-last-child(9), .v-row .v-col--auto:nth-last-child(9) ~ .v-col--auto {
		width: 11.11111111%;
		width: calc((100% - 15px * 8) / 9)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(9), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(9) ~ .v-col--auto {
		width: 11.11111111%
	}

	.v-row .v-col--auto:nth-last-child(10), .v-row .v-col--auto:nth-last-child(10) ~ .v-col--auto {
		width: 10%;
		width: calc((100% - 15px * 9) / 10)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(10), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(10) ~ .v-col--auto {
		width: 10%
	}

	.v-row .v-col--auto:nth-last-child(11), .v-row .v-col--auto:nth-last-child(11) ~ .v-col--auto {
		width: 9.09090909%;
		width: calc((100% - 15px * 10) / 11)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(11), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(11) ~ .v-col--auto {
		width: 9.09090909%
	}

	.v-row .v-col--auto:nth-last-child(12), .v-row .v-col--auto:nth-last-child(12) ~ .v-col--auto {
		width: 8.33333333%;
		width: calc((100% - 15px * 11) / 12)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(12), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(12) ~ .v-col--auto {
		width: 8.33333333%
	}

	.v-row .v-col--auto:nth-last-child(13), .v-row .v-col--auto:nth-last-child(13) ~ .v-col--auto {
		width: 7.69230769%;
		width: calc((100% - 15px * 12) / 13)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(13), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(13) ~ .v-col--auto {
		width: 7.69230769%
	}

	.v-row .v-col--auto:nth-last-child(14), .v-row .v-col--auto:nth-last-child(14) ~ .v-col--auto {
		width: 7.14285714%;
		width: calc((100% - 15px * 13) / 14)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(14), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(14) ~ .v-col--auto {
		width: 7.14285714%
	}

	.v-row .v-col--auto:nth-last-child(15), .v-row .v-col--auto:nth-last-child(15) ~ .v-col--auto {
		width: 6.66666667%;
		width: calc((100% - 15px * 14) / 15)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(15), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(15) ~ .v-col--auto {
		width: 6.66666667%
	}

	.v-row .v-col--auto:nth-last-child(16), .v-row .v-col--auto:nth-last-child(16) ~ .v-col--auto {
		width: 6.25%;
		width: calc((100% - 15px * 15) / 16)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(16), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(16) ~ .v-col--auto {
		width: 6.25%
	}

	.v-row .v-col--auto:nth-last-child(17), .v-row .v-col--auto:nth-last-child(17) ~ .v-col--auto {
		width: 5.88235294%;
		width: calc((100% - 15px * 16) / 17)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(17), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(17) ~ .v-col--auto {
		width: 5.88235294%
	}

	.v-row .v-col--auto:nth-last-child(18), .v-row .v-col--auto:nth-last-child(18) ~ .v-col--auto {
		width: 5.55555556%;
		width: calc((100% - 15px * 17) / 18)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(18), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(18) ~ .v-col--auto {
		width: 5.55555556%
	}

	.v-row .v-col--auto:nth-last-child(19), .v-row .v-col--auto:nth-last-child(19) ~ .v-col--auto {
		width: 5.26315789%;
		width: calc((100% - 15px * 18) / 19)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(19), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(19) ~ .v-col--auto {
		width: 5.26315789%
	}

	.v-row .v-col--auto:nth-last-child(20), .v-row .v-col--auto:nth-last-child(20) ~ .v-col--auto {
		width: 5%;
		width: calc((100% - 15px * 19) / 20)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(20), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(20) ~ .v-col--auto {
		width: 5%
	}

	.v-row .v-col--auto:nth-last-child(21), .v-row .v-col--auto:nth-last-child(21) ~ .v-col--auto {
		width: 4.76190476%;
		width: calc((100% - 15px * 20) / 21)
	}

	.v-row.v-row--no-gutter .v-col--auto:nth-last-child(21), .v-row.v-row--no-gutter .v-col--auto:nth-last-child(21) ~ .v-col--auto {
		width: 4.76190476%
	}

	.panel {
		border-radius: 0;
		border: 1px solid #ddd;
		overflow: hidden;
	}

	.panel p {
		display: inline-block;
		margin: 0
	}

	.panel__heading {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #ddd;
		background: #f5f5f5;
		position: relative;
	}

	.panel__heading h3 {
		font-size: 15px;
		padding: 9px 15px;
		margin: 0
	}

	.panel__body {
		background: #fff;
		min-height: 40px
	}

	.panel__body > .panel {
		margin: 10px
	}

	.panel__body p {
		width: 100%;
		padding: 0;
		font-size: 14px;
		color: #666
	}

	.panel--filter {
		font-size: 14px;
		line-height: 20px;
	}

	.panel--filter .panel__body--list {
		text-align: left;
	}

	.panel__body--list {
		background: #fff;
	}

	.panel__body--item, .panel__body .panel__placeholder {
		width: 100%;
		min-height: 40px;
		line-height: 25px;
		border-bottom: 1px solid #ddd;
		padding: 5px 15px;
		background: #fff;
		box-sizing: border-box;
	}

	.panel__body--item.no-padding-left {
		padding-left: 0
	}

	.panel__body--item:last-child {
		border-bottom: none
	}

	.panel__body--item > .panel {
		margin: 15px 0
	}

  .panel__body--item input {
    margin-right: 5px;
  }

  .panel__body--item:has(input[type="radio"]:checked) {
    background-color: #0090d01c;
  }

	.panel .panel__placeholder {
		background: #f5f5f5
	}

  .panel__body--item:hover {
    cursor: move;
  }

	.panel.panel--info .panel__body {
		padding: 25px
	}

	.main {
		min-height: 350px;
		height: 100%;
	}

	.header {
		width: 100%;
		height: 420px;
		border-bottom: 1px solid #f5f5f5;
		margin-bottom: 30px;
		padding-bottom: 50px;
		box-sizing: border-box
	}

	.header__container {
		max-width: 980px;
		min-width: 730px;
		height: 100%;
		margin: 0 auto;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-direction: column;
		flex-direction: column;
		-ms-flex-pack: end;
		justify-content: flex-end;
		-ms-flex-align: center;
		align-items: center
	}

	.header__container a {
		margin-bottom: 20px
	}

	.header__container .logo {
		color: #fff
	}

	.header__container h3 {
		margin: 5px 0;
		font-size: 18px;
		font-weight: 400
	}

	.header__container .buttons {
		width: 200px;
		margin: 20px 0;
		text-align: center
	}

	.menus {
		display: -ms-flexbox;
		display: flex
	}

	.menus__item {
		padding: 0 10px
	}

	.unknown[data-v-bb0a8c52] {
		color: #ddd
	}

	.handleDemo .vddl-placeholder {
		width: 100%;
		height: 40px;
		background: #f5f5f5;
		border-bottom: 1px solid #f5f5f5
	}

	.handleDemo .vddl-dragging.vddl-dragging-source {
		display: none
	}

	.handleDemo .vddl-list div {
		display: -ms-flexbox;
		display: flex;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none
	}

	.handleDemo .handle {
		cursor: move;
		width: 40px;
		height: 40px;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAABN0lEQVR4Xu3ZUQqCQABFUV2iK3WJRd8VzHBFajh9+8iO1wjbN68ksKe18QYwRgAQYBSIcwUCjAJxrkCAUSDOFQgwCsS5AgFGgThXIMAoEOfDBR7H8Yjv9Vfz8zyHbIYOen1ygJ+vP8Av94UC4xcGwF8DjOez7Hz4O3BZgfjBAAKMAnGuQIBRIM4VCDAKxLkCAUaBOFcgwCgQ5woEGAXiXIF3AXqk75H+VGueSE9xvR8MEGAUiPPLC4zns+zcz5h4aQECjAJxrkCAUSDOFQgwCsS5AgFGgThXIMAoEOcKBBgF4lyBdwH6T8R/IlOtXf5AVYEKVOCUQDz48ls4ns+ycz9j4qUFCDAKxLkCAUaBOFcgwCgQ5woEGAXiXIEAo0CcKxBgFIhzBQKMAnGuQIBRIM4VCDAKxPkTOFs8UVs5wLoAAAAASUVORK5CYII=) 50% no-repeat;
		background-size: 20px 20px
	}

	.handleDemo .name {
		line-height: 40px
	}

	.nodrag {
		-ms-flex: 1;
		flex: 1;
		display: -ms-flexbox;
		display: flex
	}

	.panel__body--list.padding {
		padding: 7px
	}

	.panel__body--list.padding:after {
		content: "";
		clear: both;
		display: block;
		width: 100%;
		height: 0;
		visibility: hidden
	}

	.horizontal-item, .item {
		background: #42b983
	}

	.horizontal-item, .horizontal .vddl-placeholder, .item {
		color: #fff;
		width: 40px;
		height: 40px;
		margin: 7px;
		text-align: center;
		line-height: 16px;
		padding: 2px;
		float: left;
		border-radius: 4px;
		font-size: 13px;
		box-sizing: border-box
	}

	.horizontal .vddl-placeholder {
		background: #42b983;
		background: #f5f5f5
	}

	.horizontal .horizontal__container {
		min-height: 166px
	}

	.horizontal .horizontal__container > .vddl-placeholder {
		width: 100%;
		height: 166px;
		margin: 10px 0;
		border-radius: 0;
		padding: 0
	}

	@font-face {
		font-family: icomoon;
		src: url(data:application/vnd.ms-fontobject;base64,UAYAAKwFAAABAAIAAAAAAAAAAAAAAAAAAAABAJABAAAAAExQAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAfRqG2QAAAAAAAAAAAAAAAAAAAAAAAA4AaQBjAG8AbQBvAG8AbgAAAA4AUgBlAGcAdQBsAGEAcgAAABYAVgBlAHIAcwBpAG8AbgAgADEALgAwAAAADgBpAGMAbwBtAG8AbwBuAAAAAAAAAQAAAAsAgAADADBPUy8yDxIG4AAAALwAAABgY21hcP+AvfUAAAEcAAAAZGdhc3AAAAAQAAABgAAAAAhnbHlmWe6oMAAAAYgAAAHMaGVhZBDufvMAAANUAAAANmhoZWEHwgPJAAADjAAAACRobXR4FgABAAAAA7AAAAAgbG9jYQHKAZYAAAPQAAAAEm1heHAADwBmAAAD5AAAACBuYW1lmUoJ+wAABAQAAAGGcG9zdAADAAAAAAWMAAAAIAADA5oBkAAFAAACmQLMAAAAjwKZAswAAAHrADMBCQAAAAAAAAAAAAAAAAAAAAEQAAAAAAAAAAAAAAAAAAAAAEAAAOocA8D/wABAA8AAQAAAAAEAAAAAAAAAAAAAACAAAAAAAAMAAAADAAAAHAABAAMAAAAcAAMAAQAAABwABABIAAAADgAIAAIABgABACDpJukw6hz//f//AAAAAAAg6SbpL+oc//3//wAB/+MW3hbWFesAAwABAAAAAAAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAAGAED/wAPAA8AAGQAhADkARwBVAGMAAAEuAScuAScuASMhIgYVERQWMyEyNjURNCYnJx4BFyM1HgETFAYjISImNRE0NjMwMzoBMzIxFRQWOwEDISImNTQ2MyEyFhUUBichIiY1NDYzITIWFRQGJyEiJjU0NjMhMhYVFAYDlhEtGRozFycpC/4QIS8vIQLgIS8OHIUXJQ2aESmGCQf9IAcJCQdNTrpNThMN4KD+QA0TEw0BwA0TEw3+QA0TEw0BwA0TEw3+QA0TEw0BwA0TEwLbFzMaGS0RHA4vIfygIS8vIQJwCyknNhcpEZoNJfzoBwkJBwNgBwngDRP+ABMNDRMTDQ0TgBMNDRMTDQ0TgBMNDRMTDQ0TAAAAAQAAAAAEAANAAAUAAAEXIREhEQHAgAHA/AADQID9QANAAAAAAgAAAAAEAANAAAMACgAAJRMhAxMDESEXIRUDQMD8wMCAgAEggAGgAAIA/gACQP3AA0CAgAAAAAABAMAAQANAA0AAAgAAEwkBwAKA/YADQP6A/oAAAQAAAAAAANmGGn1fDzz1AAsEAAAAAADW6B07AAAAANboHTsAAP/ABAADwAAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAAEAAABAAAAAAAAAAAAAAAAAAAACAQAAAAAAAAAAAAAAAIAAAAEAABABAAAAAQAAAAEAADAAAAAAAAKABQAHgCqALwA2ADmAAAAAQAAAAgAZAAGAAAAAAACAAAAAAAAAAAAAAAAAAAAAAAAAA4ArgABAAAAAAABAAcAAAABAAAAAAACAAcAYAABAAAAAAADAAcANgABAAAAAAAEAAcAdQABAAAAAAAFAAsAFQABAAAAAAAGAAcASwABAAAAAAAKABoAigADAAEECQABAA4ABwADAAEECQACAA4AZwADAAEECQADAA4APQADAAEECQAEAA4AfAADAAEECQAFABYAIAADAAEECQAGAA4AUgADAAEECQAKADQApGljb21vb24AaQBjAG8AbQBvAG8AblZlcnNpb24gMS4wAFYAZQByAHMAaQBvAG4AIAAxAC4AMGljb21vb24AaQBjAG8AbQBvAG8Abmljb21vb24AaQBjAG8AbQBvAG8AblJlZ3VsYXIAUgBlAGcAdQBsAGEAcmljb21vb24AaQBjAG8AbQBvAG8AbkZvbnQgZ2VuZXJhdGVkIGJ5IEljb01vb24uAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=);
		src: url(data:application/vnd.ms-fontobject;base64,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#iefix) format("embedded-opentype"), url(data:application/x-font-ttf;base64,AAEAAAALAIAAAwAwT1MvMg8SBuAAAAC8AAAAYGNtYXD/gL31AAABHAAAAGRnYXNwAAAAEAAAAYAAAAAIZ2x5ZlnuqDAAAAGIAAABzGhlYWQQ7n7zAAADVAAAADZoaGVhB8IDyQAAA4wAAAAkaG10eBYAAQAAAAOwAAAAIGxvY2EBygGWAAAD0AAAABJtYXhwAA8AZgAAA+QAAAAgbmFtZZlKCfsAAAQEAAABhnBvc3QAAwAAAAAFjAAAACAAAwOaAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADqHAPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQASAAAAA4ACAACAAYAAQAg6SbpMOoc//3//wAAAAAAIOkm6S/qHP/9//8AAf/jFt4W1hXrAAMAAQAAAAAAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAABgBA/8ADwAPAABkAIQA5AEcAVQBjAAABLgEnLgEnLgEjISIGFREUFjMhMjY1ETQmJyceARcjNR4BExQGIyEiJjURNDYzMDM6ATMyMRUUFjsBAyEiJjU0NjMhMhYVFAYnISImNTQ2MyEyFhUUBichIiY1NDYzITIWFRQGA5YRLRkaMxcnKQv+ECEvLyEC4CEvDhyFFyUNmhEphgkH/SAHCQkHTU66TU4TDeCg/kANExMNAcANExMN/kANExMNAcANExMN/kANExMNAcANExMC2xczGhktERwOLyH8oCEvLyECcAspJzYXKRGaDSX86AcJCQcDYAcJ4A0T/gATDQ0TEw0NE4ATDQ0TEw0NE4ATDQ0TEw0NEwAAAAEAAAAABAADQAAFAAABFyERIREBwIABwPwAA0CA/UADQAAAAAIAAAAABAADQAADAAoAACUTIQMTAxEhFyEVA0DA/MDAgIABIIABoAACAP4AAkD9wANAgIAAAAAAAQDAAEADQANAAAIAABMJAcACgP2AA0D+gP6AAAEAAAAAAADZhhp9Xw889QALBAAAAAAA1ugdOwAAAADW6B07AAD/wAQAA8AAAAAIAAIAAAAAAAAAAQAAA8D/wAAABAAAAAAABAAAAQAAAAAAAAAAAAAAAAAAAAgEAAAAAAAAAAAAAAACAAAABAAAQAQAAAAEAAAABAAAwAAAAAAACgAUAB4AqgC8ANgA5gAAAAEAAAAIAGQABgAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAHAAAAAQAAAAAAAgAHAGAAAQAAAAAAAwAHADYAAQAAAAAABAAHAHUAAQAAAAAABQALABUAAQAAAAAABgAHAEsAAQAAAAAACgAaAIoAAwABBAkAAQAOAAcAAwABBAkAAgAOAGcAAwABBAkAAwAOAD0AAwABBAkABAAOAHwAAwABBAkABQAWACAAAwABBAkABgAOAFIAAwABBAkACgA0AKRpY29tb29uAGkAYwBvAG0AbwBvAG5WZXJzaW9uIDEuMABWAGUAcgBzAGkAbwBuACAAMQAuADBpY29tb29uAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG5SZWd1bGFyAFIAZQBnAHUAbABhAHJpY29tb29uAGkAYwBvAG0AbwBvAG5Gb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format("truetype"), url(data:application/font-woff;base64,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) format("woff"), url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiID4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWV0YWRhdGE+R2VuZXJhdGVkIGJ5IEljb01vb248L21ldGFkYXRhPgo8ZGVmcz4KPGZvbnQgaWQ9Imljb21vb24iIGhvcml6LWFkdi14PSIxMDI0Ij4KPGZvbnQtZmFjZSB1bml0cy1wZXItZW09IjEwMjQiIGFzY2VudD0iOTYwIiBkZXNjZW50PSItNjQiIC8+CjxtaXNzaW5nLWdseXBoIGhvcml6LWFkdi14PSIxMDI0IiAvPgo8Z2x5cGggdW5pY29kZT0iJiN4MjA7IiBob3Jpei1hZHYteD0iNTEyIiBkPSIiIC8+CjxnbHlwaCB1bmljb2RlPSImI3hlOTI2OyIgZ2x5cGgtbmFtZT0iZmlsZS10ZXh0MiIgZD0iTTkxNy44MDYgNzMwLjkyNGMtMjIuMjEyIDMwLjI5Mi01My4xNzQgNjUuNy04Ny4xNzggOTkuNzA0cy02OS40MTIgNjQuOTY0LTk5LjcwNCA4Ny4xNzhjLTUxLjU3NCAzNy44Mi03Ni41OTIgNDIuMTk0LTkwLjkyNCA0Mi4xOTRoLTQ5NmMtNDQuMTEyIDAtODAtMzUuODg4LTgwLTgwdi04NjRjMC00NC4xMTIgMzUuODg4LTgwIDgwLTgwaDczNmM0NC4xMTIgMCA4MCAzNS44ODggODAgODB2NjI0YzAgMTQuMzMyLTQuMzcyIDM5LjM1LTQyLjE5NCA5MC45MjR6TTc4NS4zNzQgNzg1LjM3NGMzMC43LTMwLjcgNTQuOC01OC4zOTggNzIuNTgtODEuMzc0aC0xNTMuOTU0djE1My45NDZjMjIuOTg0LTE3Ljc4IDUwLjY3OC00MS44NzggODEuMzc0LTcyLjU3MnpNODk2IDE2YzAtOC42NzItNy4zMjgtMTYtMTYtMTZoLTczNmMtOC42NzIgMC0xNiA3LjMyOC0xNiAxNnY4NjRjMCA4LjY3MiA3LjMyOCAxNiAxNiAxNiAwIDAgNDk1Ljk1NiAwLjAwMiA0OTYgMHYtMjI0YzAtMTcuNjcyIDE0LjMyNi0zMiAzMi0zMmgyMjR2LTYyNHpNNzM2IDEyOGgtNDQ4Yy0xNy42NzIgMC0zMiAxNC4zMjYtMzIgMzJzMTQuMzI4IDMyIDMyIDMyaDQ0OGMxNy42NzQgMCAzMi0xNC4zMjYgMzItMzJzLTE0LjMyNi0zMi0zMi0zMnpNNzM2IDI1NmgtNDQ4Yy0xNy42NzIgMC0zMiAxNC4zMjYtMzIgMzJzMTQuMzI4IDMyIDMyIDMyaDQ0OGMxNy42NzQgMCAzMi0xNC4zMjYgMzItMzJzLTE0LjMyNi0zMi0zMi0zMnpNNzM2IDM4NGgtNDQ4Yy0xNy42NzIgMC0zMiAxNC4zMjYtMzIgMzJzMTQuMzI4IDMyIDMyIDMyaDQ0OGMxNy42NzQgMCAzMi0xNC4zMjYgMzItMzJzLTE0LjMyNi0zMi0zMi0zMnoiIC8+CjxnbHlwaCB1bmljb2RlPSImI3hlOTJmOyIgZ2x5cGgtbmFtZT0iZm9sZGVyIiBkPSJNNDQ4IDgzMmwxMjgtMTI4aDQ0OHYtNzA0aC0xMDI0djgzMnoiIC8+CjxnbHlwaCB1bmljb2RlPSImI3hlOTMwOyIgZ2x5cGgtbmFtZT0iZm9sZGVyLW9wZW4iIGQ9Ik04MzIgMGwxOTIgNTEyaC04MzJsLTE5Mi01MTJ6TTEyOCA1NzZsLTEyOC01NzZ2ODMyaDI4OGwxMjgtMTI4aDQxNnYtMTI4eiIgLz4KPGdseXBoIHVuaWNvZGU9IiYjeGVhMWM7IiBnbHlwaC1uYW1lPSJwbGF5MyIgZD0iTTE5MiA4MzJsNjQwLTM4NC02NDAtMzg0eiIgLz4KPC9mb250PjwvZGVmcz48L3N2Zz4=#icomoon) format("svg");
		font-weight: 400;
		font-style: normal
	}

	[class*=" icon-"], [class^=icon-] {
		font-family: icomoon;
		speak: none;
		font-style: normal;
		font-weight: 400;
		font-variant: normal;
		text-transform: none;
		line-height: 1;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale
	}

	.icon-file-text2:before {
		content: "\E926"
	}

	.icon-folder:before {
		content: "\E92F"
	}

	.icon-folder-open:before {
		content: "\E930"
	}

	.icon-play3:before {
		content: "\EA1C"
	}

	.vddl-tree .vddl-label {
		font-size: 1rem;
		margin-left: .3rem
	}

	.vddl-tree .vddl-list {
		padding-left: 1.2rem;
		min-height: 4px
	}

	.vddl-tree .icon.leaf {
		margin-left: 1.2rem
	}

	.vddl-tree .vddl-placeholder {
		height: 1.2rem;
		background: #ddd
	}

	.icon {
		width: 1.2rem;
		height: 1.2rem;
		display: block;
		float: left;
		text-align: center
	}

	.icon i {
		display: inline-block;
		font: normal normal normal 14px/1 icomoon;
		font-size: inherit;
		text-rendering: auto;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale
	}

	.icon.leaf {
		color: gray
	}

	.icon.leaf i:before {
		content: "\E926"
	}

	.icon.node {
		color: orange
	}

	.icon.node i:before {
		content: "\E92F"
	}

	.icon.node i.open:before {
		content: "\E930"
	}

	.icon.open-close.open i:before {
		content: "-"
	}

	.icon.open-close i:before {
		content: "+"
	}

	.panel__body--list .vddl-placeholder {
		width: 100%;
	}

	.vddl-placeholder {
		width: 100%;
		min-height: 61px;
		border-bottom: 1px solid #ddd;
		padding: 0 15px;
		margin-bottom: 15px;
		background: #0090d01c
	}

	.new-elements .button {
		border: 1px solid #42b983;
		text-align: center;
		height: 40px;
		line-height: 40px;
		background-color: #42b983;
		color: #fff;
		cursor: move;
		font-size: 14px
	}

	.new-elements .vddl-dragging-source {
		display: block;
	}

	.disable-element .button {
		background-color: #e32822;
		border: 1px solid #e32822;
		cursor: pointer
	}

	.save-element .button {
		background-color: #6888a8;
		border: 1px solid #6888a8;
		cursor: pointer
	}

	.selected {
		background: #0090d01c
	}

	.selected-item .panel__body {
		line-height: 40px
	}

	.ashcan .ashcan-logo {
		display: block;
		width: 40px;
		margin: 10px auto
	}

	.ashcan .vddl-placeholder {
		display: none
	}

	.simple .vddl-placeholder {
		line-height: 40px;
		border-bottom: 1px solid #ddd;
		font-size: 14px;
		padding-left: 15px
	}

	.red {
		color: red
	}

	.mutations {
		text-align: center
	}

	.mutations h3 {
		font-size: 16px;
		margin: 0
	}

	.mutations p {
		font-size: 14px;
		line-height: 20px;
		color: #666
	}

	.footer {
		border-top: 1px solid #f5f5f5;
		text-align: center;
		font-size: 14px
	}

	.demo__title span {
		color: #42b983
	}

	.clear {
    position: absolute;
    transition: all .2s;
    top: -10px;
    right: 5%;
    font-size: 20px;
    font-weight: bold;
    background-color: white;
    margin: 0;
    padding: 0;
    height: 20px;
	}

	.clear:hover {
		cursor: pointer;
		color: #ff00008a;
	}

	.tabs {
		width: 55%;
		margin: 0 auto;
	}

	.tabs label {
		font-weight: normal;
		display: contents;
	}

	.noselect {
		cursor: default;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.selected-element p {
		word-wrap: break-word;
	}

	.container-control, .tab-control, .filter-control {
		width: 100%;
		margin: 15px 0;
	}

	.filter-control {
		margin: 15px;
    position: relative;
	}

	.container-control input, .tab-control input, .filter-control input {
		width: 94%;
		height: 29px;
		padding: 0 5px;
		border-radius: 2px;
		border: 1px solid #ababab;
	}

	.filter-control input {
    border-radius: 0;
	}

  .filter-control input:focus {
    outline: none;
  }

	.tabs li {
		text-align: left;
		width: 100%;
		margin: 0;
		padding: 0;
		font-size: 16px;
		color: #666;
	}

	.panel--tabs .tabs {
		width: 100%;
	}

	.dn {
		display: none;
	}

  .filter .panel__body--list {
    max-height: 75vh;
  }

  .validation-rules .scroll_panel__body {
    max-height: 79.49vh;
    //overflow-x: auto;
  }

  .new-elements .panel__body--list {
    max-height: 75vh;
  }

	.filter .panel__body--list, .item_structure .panel__body--list, .new-elements .panel__body--list {
		overflow-x: auto;
	}

	span {
		color: #6888a8;
	}

	.tab--preview {
		padding: 11px 15px;
		background-color: #f5f5f5;
		border-radius: 0;
		margin: 0;
		border: 1px solid #ddd;
		font-size: 15px;
    height: 41px;
	}

	.tabs--item {
		height: 40px;
		line-height: 40px;
		border-bottom: 1px solid #ddd;
		padding: 0 15px;
		background: #fff;
		box-sizing: border-box;
		display: inline-block;
	}

	.tabs label:hover {
		cursor: pointer;
	}

	.tabs .vddl-draggable:hover .edit,
	.tab .panel__heading:hover .edit,
	.group .panel__heading:hover .edit {
		display: block;
    right: 35px;
	}

  .tabs .vddl-draggable:hover .delete,
  .tab .panel__heading:hover .delete,
  .group .panel__heading:hover .delete {
    display: block;
    right: 10px;
  }

	.drag {
		color: #c1c1c1;
		margin: 0 10px 0 0;
	}

	.tabs .vddl-draggable .edit,
	.tabs .vddl-draggable .save,
  .tabs .vddl-draggable .delete,
  .tabs .vddl-draggable .add,
	.tab .panel__heading .edit,
	.tab .panel__heading .save,
  .tab .panel__heading .delete,
  .tab .panel__heading .add,
	.group .panel__heading .edit,
	.group .panel__heading .save,
  .group .panel__heading .delete,
  .group .panel__heading .add,
  .panel__heading .add-tab
	{
		position: absolute;
		top: 9px;
		color: gray;
		padding: 4px;
		border-radius: 15px;
		transition: .5s;
		cursor: pointer;
	}

  .panel__heading .add-tab {
    right: 10px;
    background-color: #ffffff;
  }

	.tabs .vddl-draggable .edit,
	.tabs .vddl-draggable .save {
		right: 35px;
		background-color: #f5f5f5;
	}

	.tab .panel__heading .edit,
	.tab .panel__heading .save {
		right: 35px;
		background-color: #ffffff;
	}

  .tabs .vddl-draggable .delete,
  .tab .panel__heading .delete {
    right: 10px;
    background-color: #ffffff;
    color: #ff00008a;
  }

  .tabs .vddl-draggable .add,
  .tab .panel__heading .add {
    right: 60px;
    background-color: #ffffff;
  }

	.group .panel__heading .edit,
	.group .panel__heading .save {
		right: 35px;
	}

	.save {
		display: block;
	}

	.edit:hover {
		color: #6888a8;
	}

  .delete:hover {
    color: #6888a8;
  }

	.tabs .vddl-draggable .text-edit {
		width: 75%;
	}

	.tab .panel__heading .text-edit {
		width: 70%;
		margin: 0 10px;
		padding-left: 10px;
	}

	.group .panel__heading .text-edit {
		width: 70%;
	}

	.text-edit {
		height: 29px;
	}

	.search-highlight-tab {
		background-color: #fff3cd !important;
		border-left: 3px solid #ffc107 !important;
	}

	.search-highlight-tab label {
		color: #0c5460;
	}

  .validation-rules-tab-content {
    padding: 0 15px;
    overflow-x: scroll;
    max-height: 75vh;
  }
</style>
